module.exports = __webpack_public_path__ + "assets/img/02a.837be492.jpg";